<template>
  <div 
    v-if="imageDimensions" 
    :class="[
      'path-wrapper',
      pathType ? `path-${pathType}` : ''
    ]"
  >
    <svg :viewBox="`0 0 ${imageDimensions.width} ${imageDimensions.height}`">
      <polyline 
        :points="computedPoints"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: [
    'points',
    'pathType',
    'imageDimensions',
  ],
  computed: {
    computedPoints() {
      return this.points.map((pair)=> {
        return pair.join(',')
      }).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.path-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  fill: none;
  stroke: #13bf88;
  stroke-width: 2px;
  stroke-linejoin: round;
  &.path-smoke {
    stroke: #13bf88;
  }
  &.path-flame {
    stroke: #dd4433;
  }
}
</style>